function debugLog(name: string, count: number, arg?: unknown): void {
	console.debug(`[Event][${name}] Dispatched ${count} subscriber(s).`, arg);
}

export { debugLog };
